import "./style.scss";

import { CircularProgress, TablePagination } from "@mui/material";
import Pagination from "components/shared/Pagination";

import TableBody from "./TableBody";
import TableHeader from "./TableHeader";
import type { SubscriptionTableColumn, SubscriptionTableRow } from "./types";

interface SubscriptionTableProps {
    columns: SubscriptionTableColumn[];
    data: SubscriptionTableRow[];
    isLoading: boolean;
    page: number;
    rowsPerPage: number;
    totalCount: number;
    onCellSave?: (rowId: string | number, columnId: string, value: any) => void;
    onPageChange: (event: unknown, newPage: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    rowsPerPageOptions?: number[];
}

const SubscriptionTable = ({
    columns,
    data,
    isLoading,
    page,
    rowsPerPage,
    totalCount,
    onCellSave,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = [10, 25, 50],
}: SubscriptionTableProps) => {
    return (
        <div className="subscription-table-container">
            <div className="subscription-table-wrapper">
                <table className="subscription-table">
                    <TableHeader columns={columns} />
                    {isLoading ? (
                        <tbody>
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    style={{
                                        textAlign: "center",
                                        padding: "0",
                                        height: "440px",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    <CircularProgress size={32} />
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <TableBody rows={data} columns={columns} onCellSave={onCellSave} />
                    )}
                </table>
            </div>
            <TablePagination
                component={() => (
                    <Pagination
                        rowsPerPageOptions={rowsPerPageOptions}
                        rowsPerPage={rowsPerPage}
                        currentPageSize={data.length}
                        page={page}
                        onPageChange={onPageChange}
                        onRowsPerPageChange={onRowsPerPageChange}
                        type="subscriptions"
                        count={totalCount}
                        sticky={false}
                    />
                )}
                count={-1}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default SubscriptionTable;
